import "../Components/Footer.css";
import { Link } from "react-router-dom";
import logofooter from "../Components/Assets/Home-Header-Footer/hussme-white-web.png";
import mail from "../Components/Assets/Home-Header-Footer/envelope (1).png";
import mobile from "../Components/Assets/Home-Header-Footer/outgoing.png";

/**
 * Footer component that displays company information, navigation links, and contact details
 * Includes social media links and copyright information
 */

export function Footer() {
  return (
    <div className="footer">
      <div className="footer-col">
        {/* Company branding and description */}
        <div className="col-1">
          <img src={logofooter} alt="Hussme Logo" />
          <p className="footer-para">
            Streaming the business process for growth and bring in the out of
            the box solution to reduce expenses
          </p>
        </div>

        {/* Primary navigation links */}
        <div className="col-2">
          <ul>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/service">Services</Link>
            </li>
            <li>
              <Link to="/blog">Blog</Link>
            </li>
            <li>
              <Link to="/contact">Contact Us</Link>
            </li>
          </ul>
        </div>

        {/* Legal and business links */}
        <div className="col-3">
          <ul>
            <li>
              <Link to="/privacy-policy">Privacy Policy</Link>
            </li>
            <li>
              <Link to="/terms-conditions">Terms & Condition</Link>
            </li>
            
          </ul>
        </div>

        {/* Contact information and social media */}
        <div className="col-4">
          <Link to="/contact">
            <div className="contact-btn">Contact Us</div>
          </Link>

          {/* Contact details */}
          <div className="cen-left">
            <div className="mobile-footer">
               <img src={mobile} alt="Email" />
             
              <a href="tel:+1 (803) 200-2817" rel="noopener noreferrer">
                +1 (803) 200-2817
              </a>
            </div>
            <div className="mail">
              <img src={mail} alt="Phone" />
              <a href="mailto:support@hussme.com" rel="noopener noreferrer">
                support@hussme.com
              </a>
            </div>
          </div>

          {/* Social media links */}
          <div className="social-media">
            <a
              href="https://x.com/@hussmeSupport"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="x-icn"></div>
            </a>
            <a
              href="https://www.instagram.com/hussme_insta"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="insta-icn"></div>
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=61559927194344"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="fb-icn"></div>
            </a>
            {/* <a>
              <div className="linkedin-icn"></div>
            </a> */}
          </div>
        </div>
      </div>

      {/* Copyright section */}
      <div className="copyright">
        <hr />
        <div className="copy-container">
          <h4>©All Copyrights {new Date().getFullYear()} by Husssme</h4>
        </div>
      </div>
    </div>
  );
}
